module.exports = __webpack_public_path__ + "static/media/image-14-full.f5e3de69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-14-full.jpg
// module id = 360
// module chunks = 0